var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperPlaneTilt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5665 5.0453L3.36416 12.4357C3.14373 12.4979 2.94752 12.6258 2.80177 12.8025C2.65601 12.9792 2.56765 13.1961 2.5485 13.4244C2.52934 13.6526 2.58031 13.8812 2.69457 14.0797C2.80884 14.2782 2.98097 14.4371 3.18796 14.5352L15.227 20.2379C15.4618 20.3491 15.6509 20.5382 15.7621 20.773L21.4648 32.812C21.5628 33.019 21.7217 33.1911 21.9202 33.3054C22.1187 33.4196 22.3473 33.4706 22.5756 33.4514C22.8038 33.4323 23.0208 33.3439 23.1974 33.1982C23.3741 33.0524 23.5021 32.8562 23.5642 32.6358L30.9546 6.43344C31.0089 6.24097 31.0109 6.03751 30.9604 5.84401C30.91 5.65051 30.8088 5.47396 30.6674 5.33256C30.526 5.19115 30.3494 5.08999 30.1559 5.0395C29.9624 4.98901 29.759 4.99101 29.5665 5.0453Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5901 20.4099L21.954 14.0459",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlaneTilt);
export default __webpack_public_path__ + "static/media/paperPlaneTilt.f878fe0cec93b62b02b2887d7f94aaf2.svg";
export { ForwardRef as ReactComponent };